/**
 * Chemix document version.
 * 1 - Default version
 * 2 - Add support for groups
 * 3 - Add support for theme. (Stroke width only.)
 * 4 - Add ChemMark config.
 */
export const CURRENT_CHEMIX_DOCUMENT_VERSION = 4;
